import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

type Variant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'neutral'

interface Props {
  variant?: Variant
  className?: string
  children: React.ReactNode
}

const variants: Record<Variant, string> = {
  default: 'bg-brand-100 text-brand-700',
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100 text-amber-700',
  danger:  'bg-red-100 text-red-700',
  info:    'bg-sky-100 text-sky-700',
  neutral: 'bg-slate-100 text-slate-600',
}

export function Badge({ variant = 'default', className, children }: Props) {
  return (
    <span
      className={twMerge(
        clsx('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', variants[variant]),
        className
      )}
    >
      {children}
    </span>
  )
}
